import React, { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { media, style, breakpoints } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'
import { useDispatch, useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import styled, { css } from 'styled-components'
import { Link } from 'app/common/link'
import { fetchSigninPageData } from 'shared/store/signin'
import { browserVersion, isSafari, isMobile } from 'react-device-detect'

const { yellow, bbqBrown, white } = colors

type Props = {
    onClick?: any
}

const oldSafariDesktop = !isMobile && isSafari && browserVersion < 16

const SignupBlock = ({ onClick }: Props) => {
    const intl = useIntl()
    const { signinPageState } = useSelector((state: RootState) => state)
    const loginAnimation = signinPageState?.loginAnimation
    const [width, setWidth] = useState(window.innerWidth)
    const isMobileScreen = width < breakpoints.medium

    const d = useDispatch()

    useEffect(() => {
        return window.addEventListener('resize', updateWindowDimensions)
    }, [])

    useEffect(() => {
        !loginAnimation && d(fetchSigninPageData())
    }, [])

    const updateWindowDimensions = () => setWidth(window.innerWidth)

    const ctaLabel = !!loginAnimation?.actionLabel
        ? loginAnimation?.actionLabel
        : intl.formatMessage({ id: 'signup.form.button.send' })

    return (
        <StyledContainer background={loginAnimation?.imageUrlLandscape[0]}>
            {loginAnimation?.imageUrlPortrait[0] && isMobileScreen && (
                <img
                    src={loginAnimation?.imageUrlPortrait[0]}
                    alt=""
                    width="100%"
                />
            )}
            <ButtonContainer>
                <div>
                    {onClick ? (
                        <StyledButtonMedium
                            onClick={onClick}
                            background={loginAnimation?.actionColor}>
                            {ctaLabel}
                        </StyledButtonMedium>
                    ) : (
                        <StyledLinkMedium
                            background={loginAnimation?.actionColor}
                            url={intl.formatMessage({ id: 'routes.signup' })}>
                            {ctaLabel}
                        </StyledLinkMedium>
                    )}
                </div>
            </ButtonContainer>
        </StyledContainer>
    )
}

const buttonStyle = css`
    ${style.buttonMedium};
    border: none;
    color: ${bbqBrown};
    &:hover {
        color: ${bbqBrown};
    }
`

const ButtonContainer = styled.div`
    ${media.medium`
    display: flex;
    position: relative;
    align-content: center;
    text-align: center;
    width: 100%;
    align-items: end;
    height: 100%;
    margin-bottom: 40px;
    ${oldSafariDesktop && 'top: 540px;'}
    > * {
        text-align: center;
        width: 100%;
        margin-bottom: 25px;
    }
    `};
    position: absolute;
    bottom: 0;
    margin: auto;
    width: 100%;
    text-align: center;
    > * {
        text-align: center;
        width: 100%;
        margin-bottom: 25px;
    }
`

const StyledContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 10px;
    ${media.medium`
        background: ${props =>
            `url(${props.background}) no-repeat center center`};
        background-size: cover;
        max-height: 640px;
    `};
`

const StyledButtonMedium = styled.button`
    ${style.buttonMedium};
    ${props =>
        props.background
            ? `background: ${props?.background};
            color: ${bbqBrown};
            &:hover {
                color: ${bbqBrown};
            }`
            : `background: ${yellow}; color: ${white};`};
    border: none;
`

const StyledLinkMedium = styled(Link)`
    ${buttonStyle};
    ${props =>
        props.background
            ? `background: ${props?.background};
            color: ${bbqBrown};`
            : `background: ${yellow}; color: ${white};`}
`

export { SignupBlock }
